<template>
  <div class="cmp-catalog-statement-statement_list dt-page">
    <div class="dt-page--top-bar v1">
      <div style="width: 100%" class="ut-fh">
        <div class="ut-flex">
          <div class="search" style="max-width: 1100px">
            <InputField
              :value="basicFilter.searchString"
              :placeholder="'Search'"
              :config="{
                borderStyle: 'bottom',
                maxWidth: '200px',
                minWidth: '200px',
                width: '200px',
              }"
              @keyup="onSearchInputKeyup"
            />
            <Dropdown
              :options="periodsTV"
              style="margin-top: -1px; margin-left: 20px; min-width: 200px"
              :placeholder="'Year'"
              deselect
              borderbottom
              :selected="periodsTV.find((e) => e.value == basicFilter.period)"
              v-on:selectedChange="(e) => onDropdownChange('period', e)"
              :listHeight="320"
            />

            <Dropdown
              :options="royaltyPeriodsTV"
              style="margin-top: -1px; margin-left: 20px; min-width: 200px"
              :placeholder="'Periods'"
              deselect
              borderbottom
              :selected="
                royaltyPeriodsTV.find(
                  (e) => e.value == basicFilter.royalty_period
                )
              "
              v-on:selectedChange="(e) => onDropdownChange('royalty_period', e)"
              :listHeight="320"
            />
            <DTIconButton
              :classNames="'search--advanced'"
              :text="'Advanced Search'"
              :style="{ minWidth: '148px', marginLeft: '-15px' }"
              icon="add-blue"
              @click="onAdvancedSearchClick"
            />
            <div style="margin-top: 10px" class="search-config--container">
              <div class="search-config">
                <SearchConBadge
                  v-for="sconKey of filteredAdvancedSearchConfigKeys"
                  :key="sconKey"
                  v-bind="searchConfigKey(sconKey)"
                  @delete="onSearchConDelete"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="display: flex">
      <button
        :disabled="batchPDFDownloadLoading"
        class="dt-button v5 s8"
        :class="batchPDFDownloadLoading ? 'disabled' : ''"
        style="width: 100px; margin-left: 35px; margin-top: 10px"
        v-if="checkedRoyaltyPeriodID.length > 0"
      >
        {{ $t("batch_pdf_download") }}
      </button>
      <button
        class="dt-button v5 s8"
        style="
          width: 100px;
          padding-left: 12px;
          margin-top: 10px;
          color: #ff6e6e;
          border: 1px solid #ff6e6e;
        "
        v-if="checkedRoyaltyPeriodID.length > 0"
      >
        {{ $t("Delete Accounts") }}
      </button>
    </div> -->
    <div class="dt-page--body">
      <div class="ut-fc" style="height: calc(100% - 52px)">
        <NTable
          id="catalog-statement-statement_list"
          class="h1"
          :config="tableConfig"
          :headers="headers"
          :items="list"
          :loadingFlag="loadingFlag"
          @scrollnext="onStatementNext"
        >
          <template v-slot:thead="{ thcon, thtext }">
            <tr>
              <th
                v-for="header in headers"
                v-bind="thcon(header.value)"
                :key="header.value"
              >
                <div
                  style="padding-bottom: 5px"
                  v-if="['left_options'].includes(header.value)"
                  class="header-name"
                >
                  <div class="check-buttons">
                    <img
                      @click="(e) => onHeaderCheckboxChanged(e)"
                      style="height: 18px; width: 18px"
                      :src="`static/icons/arrows/${headerCheckboxIcon}-accent.svg`"
                      class="dt-icon checkbox"
                    />
                  </div>
                </div>
                <span
                  v-else
                  :style="
                    header.ta == 'right' ? 'textAlign:end' : 'textAlign:start'
                  "
                  class="header-name"
                >
                  {{ thtext(header.value) }}
                </span>
              </th>
            </tr>
          </template>

          <template v-slot:item="{ item, tdcon }">
            <template v-if="item.process_flag == 1">
              <tr
                :class="{
                  selected: selectedRow(item),
                }"
              >
                <td v-bind="tdcon('left_options')">
        <div style="display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: -4px">
          <div class="dt-checkbox v2 s1" style="margin: auto 5px">
                    <input
                      @click="(e) => onRoyaltyPeriodCheckboxChange(e, item)"
                      type="checkbox"
                      class="invoice-select-cb"
                      :checked="
                        checkedRoyaltyPeriodID.includes(item.royalty_period_id)
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                  <div
                      class="circle-status"
                      :style="{
                        backgroundColor: `#${item['label_status_colour']}`,
                      }"
                    ></div>
        </div>
                </td>
                <td
                  v-bind="tdcon('period')"
                   @click="onClickStatement(item)"
                 
                >
                  <div class="ut-flex">
               
                    <div style="display:flex"><span class="txt-multiline-ov"
                   
                    style="font-weight: bold;"
                    >{{ item["period"] }}</span
                  >
                  &nbsp; &nbsp;
                  <b
                    class="ut-text-accent"
                    v-if="item['duplicate_royalty_period']"
                    >!!!</b
                  ></div>
                    
                  </div>
                </td>
                <td  @click="onAccountClicked(item)" v-bind="tdcon('royalty_account_name')">
                  <span class="ut-link ut-text-accent5" >{{
                      item["royalty_account_name"]
                    }}</span>
                </td>

                <td
                  style="visibility: hidden"
                  v-bind="tdcon('opening_add_ded')"
                ></td>

                <!-- <td style="visibility:hidden" v-bind="tdcon('opening_add_ded')">
                <div class="multilineLeft">
                  <span class="txtov">{{ item["opening_period_all"] }}</span>
                  <span class="txtov2">{{ item["opening_period_all"] }}</span>
                </div>
              </td> -->
                <!-- <td v-bind="tdcon('add_ded')">
                <span>{{ item["earnings"] }}</span>
              </td> -->
                <td v-bind="tdcon('royalty')">
                  <div
                    class="ut-flex ut-rowcen"
                    style="
                      position: absolute;
                      min-width: 300px;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    <span
                      title="in process..please wait"
                      class="ut-text-secondary"
                      >In process...please wait</span
                    >
                    <img
                      style="width: 10px; height: 10px; margin-left: 8px"
                      src="static/icons/loading.gif"
                      alt
                    />
                  </div>
                </td>
                <td
                  style="visibility: hidden"
                  v-bind="tdcon('payment_closing')"
                >
                  <!-- <span>{{ item["royalty_amount"] }}</span> -->
                  <div class="multilineLeft">
                    <span class="txtov">{{ item["royalty_amount"] }}</span>
                    <span class="txtov2">{{
                      item["closing_period_contract_all"]
                    }}</span>
                  </div>
                </td>
                <!-- <td v-bind="tdcon('payment')">
                <span>{{ item["payment_net_all"] }}</span>
              </td> -->
                <!-- <td v-bind="tdcon('closing')">
                <span>{{ item["closing_period_contract_all"] }}</span>
              </td> -->
                <td style="visibility: hidden" v-bind="tdcon('notes')">
                  <TextField2
                    type="text"
                    class="dbox1"
                    id="notes"
                    :showLabel="false"
                    :disabled="false"
                    :value="item['notes']"
                    :bb="'0px'"
                    :height="44"
                    @change="(e) => onTextFieldChange(e, item)"
                  />
                  <!-- <span class="txt-multiline-ov">{{ item["notes"] }}</span> -->
                </td>
                <td style="visibility: hidden" v-bind="tdcon('options')">
                  <div
                    style="
                      justify-content: flex-end;
                      display: flex;
                      height: 100%;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        item['lock_flag'] == 1 && item['total_ext_users'] > 0
                      "
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onShareClick(item)"
                        src="static/icons/eye.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                    <!-- <div
                     
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onStatementEditClick(item)"
                        src="static/icons/edit.svg"
                        class="dt-icon v5 s2"
                        alt="Set Invoice Status"
                        title="Set Royalty Statement"
                      />
                    </div> -->
                    <div
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        style="width: 25px; height: 22px"
                        v-if="!item['email1']"
                        src="static/icons/email-light.svg"
                        class="dt-icon v5"
                      />
                      <img
                        v-if="item['email1']"
                        @click.stop="(e) => emailLink(item)"
                        src="static/icons/email/email-grey.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>

                    <div class="dt-icon-container">
                      <img
                        @click.stop="(e) => onPDFClick(item)"
                        src="static/icons/pdf.svg"
                        class="dt-icon v5 s2"
                        alt
                        :title="`${$t('pdf')}`"
                      />
                    </div>

                    <div
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => printStatement(item)"
                        src="static/icons/printer.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>

                    <div
                      v-if="item['lock_flag'] == '1'"
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onLockClick(item)"
                        src="static/icons/booking/lock-closed.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                    <div
                      v-else
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onLockClick(item)"
                        color="black"
                        src="static/icons/booking/lock-open.svg"
                        class="dt-icon v5 s2"
                        alt="Lock Invoice"
                        title="Lock Invoice"
                      />
                    </div>
                    <div
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        v-if="item['lock_flag'] != '1'"
                        @click.stop="(e) => onDeleteStatements(item)"
                        src="static/icons/delete.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr :class="{
                  selected: selectedRow(item),
                }">
                <td v-bind="tdcon('left_options')">
                  <div style="display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: -4px">
                  <div class="dt-checkbox v2 s1" style="margin: auto 5px">
                    <input
                      @click="(e) => onRoyaltyPeriodCheckboxChange(e, item)"
                      type="checkbox"
                      class="invoice-select-cb"
                      :checked="
                        checkedRoyaltyPeriodID.includes(item.royalty_period_id)
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                  <div
                      class="circle-status"
                      :style="{
                        backgroundColor: `#${item['label_status_colour']}`,
                      }"
                    ></div>
                  </div>
                </td>
                <td
                  v-bind="tdcon('period')"
                   @click="onClickStatement(item)"
                 
                >
                  <div class="ut-flex">
                
                    <div style="display:flex"><span class="txt-multiline-ov"
                   
                    style="font-weight: bold;"
                    >{{ item["period"] }}</span
                  >
                  &nbsp; &nbsp;
                  <b
                    class="ut-text-accent"
                    v-if="item['duplicate_royalty_period']"
                    >!!!</b
                  ></div>
                    
                  </div>
                </td>
                <td  @click="onAccountClicked(item)" v-bind="tdcon('royalty_account_name')">
                  <span class="ut-link ut-text-accent5" >{{
                      item["royalty_account_name"]
                    }}</span>
                </td>
                <td v-bind="tdcon('opening_add_ded')">
                  <div class="multilineLeft">
                    <span class="txtov">{{ item["opening_period_all"] }}</span>
                    <span class="txtov2">{{ item["opening_period_all"] }}</span>
                  </div>
                </td>
                <!-- <td v-bind="tdcon('add_ded')">
                <span>{{ item["earnings"] }}</span>
              </td> -->
                <td v-bind="tdcon('royalty')">
                  <span class="txtov">{{ item["royalty_amount"] }}</span>
                </td>
                <td v-bind="tdcon('payment_closing')">
                  <!-- <span>{{ item["royalty_amount"] }}</span> -->
                  <div class="multilineLeft">
                    <span class="txtov">{{ item["royalty_amount"] }}</span>
                    <span class="txtov2">{{
                      item["closing_period_contract_all"]
                    }}</span>
                  </div>
                </td>
                <!-- <td v-bind="tdcon('payment')">
                <span>{{ item["payment_net_all"] }}</span>
              </td> -->
                <!-- <td v-bind="tdcon('closing')">
                <span>{{ item["closing_period_contract_all"] }}</span>
              </td> -->
                <td v-bind="tdcon('notes')">
                  <TextField2
                    type="text"
                    class="dbox1"
                    id="notes"
                    :showLabel="false"
                    :disabled="false"
                    :value="item['notes']"
                    :bb="'0px'"
                    :height="44"
                    @change="(e) => onTextFieldChange(e, item)"
                  />
                  <!-- <span class="txt-multiline-ov">{{ item["notes"] }}</span> -->
                </td>
                <td v-bind="tdcon('options')">
                  <div
                    style="
                      justify-content: flex-end;
                      display: flex;
                      height: 100%;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        item['lock_flag'] == 1 && item['total_ext_users'] > 0
                      "
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onShareClick(item)"
                        src="static/icons/eye.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                    <!-- v-if="item.royalty_ref == 'manual'" -->
                    <!-- <div
                     
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onStatementEditClick(item)"
                        src="static/icons/edit.svg"
                        class="dt-icon v5 s2"
                        alt="Set Invoice Status"
                        title="Set Royalty Statement"
                      />
                    </div> -->
                    <div
                      class="dt-icon-container ut-flex"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        style="width: 25px; height: 22px"
                        v-if="!item['email1']"
                        src="static/icons/email-light.svg"
                        class="dt-icon v5"
                      />
                      <img
                        v-if="item['email1']"
                        @click.stop="(e) => emailLink(item)"
                        src="static/icons/email/email-grey.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>

                    <div class="dt-icon-container">
                      <img
                        @click.stop="(e) => onPDFClick(item)"
                        src="static/icons/pdf.svg"
                        class="dt-icon v5 s2"
                        alt
                        :title="`${$t('pdf')}`"
                      />
                    </div>

                    <div
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => printStatement(item)"
                        src="static/icons/printer.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>

                    <div
                      v-if="item['lock_flag'] == '1'"
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onLockClick(item)"
                        src="static/icons/booking/lock-closed.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                    <div
                      v-else
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        @click.stop="(e) => onLockClick(item)"
                        color="black"
                        src="static/icons/booking/lock-open.svg"
                        class="dt-icon v5 s2"
                        alt="Lock Invoice"
                        title="Lock Invoice"
                      />
                    </div>
                    <div
                      class="dt-icon-container"
                      style="min-width: 30px; max-width: 30px"
                    >
                      <img
                        v-if="item['lock_flag'] != '1'"
                        @click.stop="(e) => onDeleteStatements(item)"
                        src="static/icons/delete.svg"
                        class="dt-icon v5 s2"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </NTable>
      </div>
      <div class="ut-flex dt-page--body--bottom-bar">
        <div class="ut-flex" style="flex: 6">
          <button
            style="text-transform: capitalize"
            class="dt-button v5 s8"
            @click="onConfirmRoyaltyDates"
          >
            {{ $dft.capHead($t("confirm_royalty_dates")) }}
          </button>
          <button
            style="text-transform: capitalize"
            class="dt-button v5 s8"
            @click="onclickOpenShopManager"
          >
            {{ $t("shop_management") }}
          </button>
          <button
            style="text-transform: capitalize"
            class="dt-button v5 s8"
            @click="onClickCheckContracts"
          >
            {{ $dft.capHead($t("check_contracts_missing_products")) }}
          </button>
        </div>
        <div class="ut-flex" style="flex: 4; justify-content: flex-end">
          <button class="dt-button v5 s8" @click="onClickBatchStatment">
            {{ $t("batch_statements") }}
          </button>
          <button @click="onClickExport" class="dt-button v5 s8">
            {{ $t("export") }}
          </button>
          <button class="dt-button v5 s8" @click="onClickEmailStatement">
            {{ $t("email_statements") }}
          </button>
        </div>
      </div>
    </div>
    <Sidewindow :value="statementDetailsFlag" @closed="onCloseStatementDetails">
      <StatementSidwindow />
    </Sidewindow>

    <ModalContainer :modalKey="'advancedSearch'" :width="'small2'">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @autoCompleteSearch="autoCompleteSearch"
        @searchDropDown="onDropdownSearch"
        @search="onAdvancedSearch"
        @cancelled="closeModal"
      />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'shopManagement'"
      :width="'1000'"
    >
      <ShopManagement @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'checkContracts'"
      :width="'1000'"
    >
      <CheckContract @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'emailStatement'"
      :width="'850'"
    >
      <EmailStatement :basicFilter="basicFilter" @cancelled="onCancel" />
    </ModalContainer>
    <!-- <ModalContainer  @cancelled="onCancel" :modalKey="'batchStatement'" :width="'400'">
      <BatchStatement  @cancelled="onCancel" />
    </ModalContainer> -->
    <!-- <ModalContainer  @cancelled="onCancel" :modalKey="'confirmRoyalty'" :width="'400'">
      <ConfirmRoyalty  @cancelled="onCancel" />
    </ModalContainer> -->
  </div>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import ShopManagement from "./shop-management";

import CheckContract from "./check-contracts-modal";
import EmailStatement from "./email-statements-modal";

import FileDownload from "js-file-download";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import AdvancedSearch from "./default-advanced-search.vue";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import {
  sendMailHref,
  subscribeSubject,
  downloadPDF,
} from "../../../../utility";

// import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
// import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";

import { createTV, tv } from "../../../../models/text-value.model";
import { statementListDefaultAdvancedSearchConfig } from "./default-advanced-search.vue";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { statementGetters } from "../../store/statement/getters";
import { statementActions } from "../../store/statement/actions";
import { statementServices } from "../../services/statements/statements.service";
import {
  getStatementDetailsSelectable,
  statementsListLDTRoutes,
  royaltyAccountsListLDTRoutes,
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import BatchStatement from "./batch-statement-modal";
import ConfirmRoyalty from "./confirm-royalty-modal";
import StatementSidwindow from "./statement-sidewindow";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { recoupableService } from "../../services/recoupable-service";
import { createSubmoduleListMixin } from "../../../../dt-plugins/submodule-list/submodule-list.mixin";
const LDTConfig = {
  entityName: "statement",
  ldtRoutes: statementsListLDTRoutes,
  detailsSelectableFunction: getStatementDetailsSelectable,
  primaryKey: "royalty_period_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.StatementDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.StatementDetails.FETCH.SINGLE,
};

export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    StatementSidwindow,
    ShopManagement,

    CheckContract,
    EmailStatement,
    BatchStatement,
    ConfirmRoyalty,

    Sidewindow,
    AdvancedSearch,
  },
  mounted: () => {},
  data: () => ({
    releasesTV: [],
    selectedRpPayment: {},
    checkedRoyaltyPeriodID: [],
    batchPDFDownloadLoading: false,
    defaultConfig: defaultConfig,
    searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
  }),
  mixins: [
    createLDTHost(LDTConfig),
    createFetchListMixin(ActionTypes.StatementList.FETCH.ALL, 30, {
      advancedSearchable: true,
      searchable: true,
      scrollable: true,
    }),
    createModalMixin("emailStatement"),
    createModalMixin("checkContracts"),
    createModalMixin("shopManagement"),
    createModalMixin("advancedSearch"),
    createAdvancedSearchHost(statementListDefaultAdvancedSearchConfig),
    createSubmoduleListMixin("statement", "royalty_period_id"),
  ],
  computed: {
    ...mapGetterObject(storeNS, statementGetters),
    advancedSearchData: function () {
      return {
        royaltyAccountTV:
          createTV(
            this.advancedSearchResponse?.royalty_accounts,
            "royalty_account_name",
            "royalty_account_id"
          ) || [],

        periodTV: [
          { text: "Year", value: "Year" },
          { text: "S1", value: "S1" },
          { text: "S2", value: "S2" },
          { text: "Q1", value: "Q1" },
          { text: "Q2", value: "Q2" },
          { text: "Q3", value: "Q3" },
          { text: "Q4", value: "Q4" },
          { text: "M01", value: "M01" },
          { text: "M02", value: "M02" },
          { text: "M03", value: "M03" },
          { text: "M04", value: "M04" },
          { text: "M05", value: "M05" },
          { text: "M06", value: "M06" },
          { text: "M07", value: "M07" },
          { text: "M08", value: "M08" },
          { text: "M09", value: "M09" },
          { text: "M10", value: "M10" },
          { text: "M11", value: "M11" },
          { text: "M12", value: "M12" },
          { text: "Manual", value: "Manual" },
        ],
        periodTypeTV: [
          { text: "Month", value: 1 },
          { text: "Bi-Month", value: 2 },
          { text: "Quarter", value: 3 },
          { text: "Semester", value: 4 },
          { text: "Year", value: 5 },
          { text: "Special", value: 6 },
        ],

        lockedTV: [
          { text: "Locked", value: "locked" },
          { text: "Unlocked", value: "unlocked" },
          { text: "All", value: "all" },
        ],
        sendOutTV: [
          { text: "Shares Active", value: 100 },
          { text: "Send Manually", value: 1 },
          { text: "Send Automatic", value: 2 },
          { text: "Don not Send", value: 3 },
        ],
        releasesTV: this.releasesTV,
        invoiceProjectTV: createTV(
          this.advancedSearchResponse?.invoice_projects,
          "invoice_project_name",
          "invoice_project_id"
        ),
        yearTV: createTV(this.advancedSearchResponse?.year, "YEAR", "YEAR"),

        labelStatusTV: createTV(
          this.advancedSearchResponse?.label_statuses,
          "label_status_name",
          "label_status_id"
        ),
      };
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    statementDetailsFlag: function () {
      return childOfOrEqualDetails(statementsListLDTRoutes, this.$route);
    },
    periodsTV: function (params) {
      return createTV(this.statementList?.periods, "period", "period");
    },
    royaltyPeriodsTV: function (params) {
      return createTV(this.statementList?.royalty_periods, "label", "value");
    },
    invoiceProjectsTV: function (params) {
      return createTV(
        this.statementList?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    statementTypeTV: (params) => [
        { text: "B2B", value: "B2B" },
        { text: "Send Manually", value: 1 },
        { text: "Send Automatically", value: 2 },
        { text: "do not send", value: 3 },
      ],
    tableConfig: () => createNTableConfig({
        fullHeight: true,
        rowHeight: 48,
      }),
    list: function () {
      return this.statementList?.statements;
    },
    headerCheckboxIcon: function () {
      return this.checkedRoyaltyPeriodID.length ==
        this.statementList?.statements.length
        ? "checkbox-tick"
        : this.checkedRoyaltyPeriodID.length == 0
        ? "checkbox"
        : "checkbox-minus";
    },
    headers: () => [
        createTableHeader("left_options", { mw: 60, ta: "center" }),
        createTableHeader("period", { mw: 150 }),
        createTableHeader("royalty_account_name", { f: 1.2 }),
        createTableHeader("opening_add_ded", { ta: "right", mw: 140 }),
        // createTableHeader("add_ded", { ta: "right", mw: 105 }),
        createTableHeader("royalty", { ta: "right", mw: 110 }),
        createTableHeader("payment_closing", { ta: "right", mw: 140 }),
        // createTableHeader("closing", { ta: "right", mw: 90 }),
        createTableHeader("notes", { f: 1.4 }),
        createTableHeader("options", { text: false, minw: 225, mw: 225 }),
      ],
  },
  methods: {
    ...mapActionObject(storeNS, statementActions),
    onPDFClick: async function (item) {
      const { royalty_account_name } = item;
      const filename = `${royalty_account_name}.pdf`;
      // const printURL = `${HttpClient.getBaseUrl()}/label.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`;
      console.log("ITEM", item);

      downloadPDF(item.stmt_link, this.$store.getters.account, filename);
    },
    onHeaderCheckboxChanged(e) {
      if (this.headerCheckboxIcon == "checkbox-tick") {
        this.checkedRoyaltyPeriodID = [];
      } else {
        this.checkedRoyaltyPeriodID = this.statementList?.statements.map(
          (r) => r.royalty_period_id
        );
      }
    },
    onRoyaltyPeriodCheckboxChange: function (e, item) {
      const checked = e.target.checked;
      if (checked) {
        this.checkedRoyaltyPeriodID = [
          ...this.checkedRoyaltyPeriodID,
          item.royalty_period_id,
        ];
      } else {
        this.checkedRoyaltyPeriodID = this.checkedRoyaltyPeriodID.filter(
          (r) => r != item.royalty_period_id
        );
      }
    },
    onAccountClicked: function (account) {
      console.log("account ", account);
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: account.royalty_account_id,
          tab: "overview",
        },
      });
    },
    fetchAdvancedSearchData: async function () {
      const advancedSearchData =
        await statementServices.rsDefaultAdvanceSearchModal();
      this.advancedSearchResponse = advancedSearchData.data;
      console.log({
        "this.advancedSearchResponse": this.advancedSearchResponse,
      });
    },
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: "",
        period: "",
        royalty_period: "",
        invoice_project: "",
        statement_type: "",
      };
    },

    onDropdownChange: function (name, value) {
      // <-- Normal Form Handling Methods
      this.basicFilter[name] = value.value;

      this.fetchListReset();
    },
    onClickStatement: function (statement) {
      console.log({ statement: statement });
      this.selectedClickedStatement = statement;
      this.$router.push({
        name: statementsListLDTRoutes.names.tab,
        params: {
          royalty_period_id: statement.royalty_period_id,
          tab: "overview",
        },
      });
    },
    onCloseStatementDetails: function () {
      // Do it later
      // this.selectedClickedContract = null;
      this.onRefresh();
      handleFromRoute(this, () => {
        this.$router.push({
          name: statementsListLDTRoutes.names.list,
        });
      });
    },
    fetchData: function () {
      //this[ActionTypes.ReleaseList.FETCH.ALL]({});
      console.log("fetchData");
      this[ActionTypes.StatementList.FETCH.ALL]({
        believe_special: this.$store.getters.account.believe_special,
        start: this.start,
        row_count: this.row_count,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      });
    },
    onRefresh: function () {
      this.fetchListNext();
    },
    // onSearchInputKeyup: function (event) {
    //   // this.searchString = event.target.value;

    //   // this.subjectSearchSubject.next(this.searchString);
    // },

    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onclickOpenShopManager: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "shop_management",
        },
      });
    },
    onStatementNext: function (value) {
      this.scrollSubject.next(value);
    },
    closeModal: function () {
      closeModalRoute(this);
    },
    onEditRPModalData(e) {
      this.onRefresh();
      closeModalRoute(this);
    },

    onTextFieldChange: function (event, item) {
      console.log(event, item);
      const payload = {
        kVal: item.royalty_period_id,
        name: event.name,
        value: event.value,
      };
      this[ActionTypes.StatementList.UPDATE.SINGLE](payload);
    },
    emailLink: function (item) {
      this.onLockClick(item);

      const body =
        "url:" + item.stmt_link + "\n shared-key: " + item.shared_key;

      const subject = "Royalty Statement " + item.royalty_account_name;

      const mails = [item.email1];

      console.log("subject,body,recepient", subject, body, mails);
      // sendMail({ subject, body, mails });
      sendMailHref({ subject, body, mails });
    },

    printStatement: function (item) {
      window.open(item.stmt_link, "_blank");
    },
    onStatementEditClick(e) {
      this.selectedRpPayment = {
        ...e,
      };
      openModalRoute(this, "edit_royalty_statement", {
        mode: "add",
        royalty_period_id: e.royalty_period_id,
      });
    },
    onLockClick: function (item) {
      const lock_flag = item.lock_flag == 0 ? 1 : 0;
      const payload = {
        kVal: item.royalty_period_id,
        name: "lock_flag",
        value: lock_flag,
      };
      this[ActionTypes.StatementList.UPDATE.SINGLE](payload);
    },
    onCancel: function () {
      closeModalRoute(this);
    },
    onClickExport: async function () {
      const fileData = await statementServices.exportStatements({
        search: this.basicFilter.searchString,
        period: this.basicFilter.period,
        royalty_period: this.basicFilter.royalty_period,
        invoice_project: this.basicFilter.invoice_project,
        statement_type: this.basicFilter.statement_type,
      });
      console.log("FILE DATA", fileData);
      FileDownload(fileData.data, "Royalty_statments.xlsx");
    },

    onConfirmRoyaltyDates: async function () {
      const resData = await statementServices.confirmRoyaltyDatesEstimation();

      console.log(resData, "::::::::::::::::::");

      const { mins, email } = resData.data;

      const confirmationResult = await ConfirmationService.createP({
        body: this.$dft.i18nFormat(this.$t("this_process_will_take_mins"), {
          minutes: mins,
          email: email,
        }),
        results: [
          createConfirmResult({
            value: "no",
            text: "Cancel",
          }),
          createConfirmResult({
            value: "yes",
            text: "OK",
            classes: ["v1"],
          }),
        ],
      });

      if (confirmationResult === "yes") {
        await statementServices.confirmAllAccountRoyaltyDatesV2();
      }

      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "confirm_royalty",
      //   },
      // });
    },
    onDropdownSearch: async function ({ e, name, tvInfo, label_id }) {
      const resData = await recoupableService.searchDropdown(e, name, label_id);

      if (tvInfo.tvArray == "releases") {
        console.log(this[tvInfo.tvArray + "TV"], resData);
        this[tvInfo.tvArray + "TV"] = [
          ...(this.advancedSearchData[tvInfo.tvArray + "TV"]?.filter(
            (e) => e.value == this.searchFilter[tvInfo.tvValue]
          ) || []),
          ...resData.data[tvInfo.tvArray]
            .map((x) => {
              return {
                text: `${x["identifier"]} - ${x["release_artist"]} - ${x["release_title"]}`,
                value: x["release_id"],
              };
            })
            .filter((e) => e.value != this.searchFilter[tvInfo.tvValue]),
        ];
        return;
      }

      this[tvInfo.tvArray + "TV"] = [
        ...(this.advancedSearchData[tvInfo.tvArray + "TV"]?.filter(
          (e) => e.value == this.searchFilter[tvInfo.tvValue]
        ) || []),
        ...createTV(
          resData.data[tvInfo.tvArray],
          tvInfo.tvText,
          tvInfo.tvValue
        ).filter((e) => e.value != this.searchFilter[tvInfo.tvValue]),
      ];
    },
    onClickCheckContracts: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "check_contracts",
        },
      });
    },
    onClickEmailStatement: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "email_statement",
        },
      });
    },

    onClickBatchStatment: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "batch_statement",
        },
      });
    },
    onDeleteStatements: async function (item) {
      console.log(item);

      const { royalty_period_id } = item;

      const resData = await statementServices.countRoyaltyPeriodPayment(
        royalty_period_id
      );

      const resInvoice = await statementServices.royaltyPeriodInvoiceInfo(
        royalty_period_id
      );

      console.log(resInvoice, ":::::::::::::");

      const invoice = resInvoice?.data?.invoice?.data;

      const derived = resInvoice?.data?.invoice?.derived;

      // console.log(derived,":::::::::::::::::");

      let msg = "";

      if (invoice) {
        msg = `${this.$t("delete_stmt_warning")}<br/>Invoice No:${
          invoice.invoice_ref
        }<br/>Invoice Date:${invoice.invoice_date}<br/>Invoice Status:${
          derived.status
        }`;
      } else {
        msg = `${this.$t("delete_stmt_warning")}`;
      }

      const confirmationResult = await ConfirmationService.createP({
        body: msg,
        results: [
          createConfirmResult({
            value: "no",
            text: "No",
          }),
          createConfirmResult({
            value: "yes",
            text: "Yes",
            classes: ["v1"],
          }),
        ],
      });

      if (confirmationResult === "yes") {
        this[ActionTypes.DefaultStatementList.DELETE.SINGLE](item);
      }
    },

    onShareClick: async function (item) {
      const res = await statementServices.raExternalUserLinks(
        item.royalty_account_id
      );

      const ext_users = res.data.ext_users[0];
      const b2b_link = ext_users.b2b_link;

      window.open(b2b_link);

      console.log(ext_users, "::::::", item);
    },
    autoCompleteSearch: async function (payload) {
      if (payload.action == "search_accounts") {
        const resData = await statementServices.searchAccounts(
          payload.searchTerm
        );
        console.log("resData", resData);
        this.advancedSearchResponse = {
          ...this.advancedSearchResponse,
          royalty_accounts: resData.data.royalty_accounts,
        };

        console.log(
          "::::::",
          this.advancedSearchResponse.royalty_accounts,
          this.advancedSearchData.royaltyAccountTV
        );

        //  createTV(
        //   resData.data.royalty_accounts,
        //   "royalty_account_name",
        //   "royalty_account_id"
        // );
      } else {
        const resData = await statementServices.searchIdProds(
          payload.searchTerm
        );
        console.log("resData", resData);

        this.advancedSearchResponse = {
          ...this.advancedSearchResponse,
          deals: resData.data.deals,
        };
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-statement-statement_list {
  height: calc(100vh - 65px) !important;
  .dt-page--body {
    --offset: 160px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
}
</style>